const getTheCurrentYear = (): number => {
    const date = new Date();

    return date.getFullYear();
};

export default getTheCurrentYear;
